import React from "react";

import { ErrorText } from "./styles";

//Interface
import { ErrorMessagePropsInterface } from "./interfaces";

const ErrorMessage = (props: ErrorMessagePropsInterface) => {
    return(
        <div className="d-flex justify-content-center mb-3">
            <ErrorText>
                {props.children}
            </ErrorText>
        </div>
    )
}

export default ErrorMessage;